<template>
<div class="footerDiv">
    <b-container>
        <b-row>
            <b-col cols="12">
                <h2 v-if="!isMobile()" class="headingFooter">OMEGA ALPHA Ⓒ 2022</h2>
                <h4 v-if="isMobile()" class="headingFooterMobile">OMEGA ALPHA Ⓒ 2022</h4>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.footerDiv
{
    margin-top: 25vh;
    height: 6vh;
    background: black;
}
.headingFooter
{
    line-height: 1.75;
    font-size: 3vh;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
}
.headingFooterMobile
{
    line-height: 2.5;
    font-size: 2vh;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/homeComp/Footer.vue